import { useTranslation } from 'react-i18next'
import EmptyState from '../components/ui/EmptyState'
import Button from '../components/ui/Button'
import { useLogout } from '../auth/useLogout'

/**
 * HR erişim kapısı (099/US3) reddettiğinde gösterilen dedike sayfa — normal `AppLayout` hiç
 * kurulmaz, bu yüzden çıkış için tek yol buradaki aksiyon butonudur (`useLogout`).
 */
export default function AccessRestrictedPage() {
  const { t } = useTranslation()
  const logout = useLogout()
  return (
    <div className="page">
      <EmptyState
        icon="pi pi-lock"
        title={t('shell.accessRestricted.title')}
        description={t('shell.accessRestricted.desc')}
        action={<Button label={t('shell.accessRestricted.logout')} onClick={logout} />}
      />
    </div>
  )
}
